module.exports = __webpack_public_path__ + "media/site_templates/www.localplasterers.com.au/images/feature_2-50694b815d6139e57866293059cc0a68.jpeg";